let feedbackIndex = new Vue({
    el: "#feedback-index",
    data: {
        showContactType: false,
        selectedContactTypeIndex: 0,
        contactTypes: [
            {
                key: 'email',
                title: '邮箱'
            },
            {
                key: 'phone',
                title: '手机'
            },
            {
                key: 'wechat',
                title: '微信'
            }
        ],
        contact: "",
        errMsg: '',
        content: '',
        verifyCode: '',
        type: '4',
        verifyCodeImgUrl: '',
    },
    mounted() {
        this.refreshVerifyCode();
    },
    methods: {
        selectContactType(type) {
            this.selectedContactTypeIndex = type;
            this.showContactType = false;
        },
        submit() {
            let that = this;
            axios.post('/feedback/submit', {
                type: that.type,
                contact_type: that.contactTypes[that.selectedContactTypeIndex].key,
                content: that.content,
                verify_code: that.verifyCode,
                contact: that.contact
            }).then(res => {
                if (res.data.code === 200) {
                    alertAlertModule.show('感谢您的反馈', '提交成功')
                } else {
                    alertAlertModule.show(res.data.msg, '提交失败', 'error')
                }
            }).catch(error => {
                alertAlertModule.show(error, '遇到错误', 'error')
            })
        },
        refreshVerifyCode() {
            let that = this;
            axios.get('/feedback/captcha?refresh').then(res => {
                that.verifyCodeImgUrl = res.data.url;
            }).catch(error => {
                alertAlertModule.show(error, '验证码加载失败', 'error')
            })
        }
    }
})